(function filterDrawerControllerFactory(root) {
  'use strict';

  function registerAlpine() {
    if (!root.Alpine || root.__jftFilterDrawerRegistered) {
      return;
    }

    root.__jftFilterDrawerRegistered = true;
    root.Alpine.data('filterDrawer', () => ({
      filtersOpen: false,
      filterTrigger: null,
      filterDialog: null,

      destroy() {
        root.themeModalAccessibility?.deactivate(this.filterDialog);
        root.document?.documentElement?.classList.remove('is-search-filter-open');
      },

      openFilters(trigger) {
        if (this.filtersOpen) {
          return;
        }

        this.filterTrigger = trigger || root.document?.activeElement;
        this.filterDialog = this.$root?.querySelector('.search-page__filters');
        this.filtersOpen = true;
        root.themeModalAccessibility?.activate(this.filterDialog);
        const backdrop = this.$root?.querySelector('.search-page__filter-backdrop');
        if (backdrop) {
          backdrop.inert = false;
        }
        this.$nextTick(() => this.$refs.filterClose?.focus({ preventScroll: true }));
      },

      closeFilters(restoreFocus = true) {
        if (!this.filtersOpen) {
          return;
        }

        const trigger = this.filterTrigger;
        this.filtersOpen = false;
        root.themeModalAccessibility?.deactivate(this.filterDialog);
        this.filterDialog = null;
        this.filterTrigger = null;

        if (restoreFocus && trigger?.isConnected) {
          this.$nextTick(() => trigger.focus({ preventScroll: true }));
        }
      },

      syncFilterState() {
        root.document?.documentElement?.classList.toggle(
          'is-search-filter-open',
          this.filtersOpen,
        );
      },

      trapFilterFocus(event) {
        root.themeModalAccessibility?.trapFocus(event, event?.currentTarget);
      },
    }));
  }

  if (root.document && typeof root.document.addEventListener === 'function') {
    root.document.addEventListener('alpine:init', registerAlpine);
  }

  if (root.Alpine) {
    registerAlpine();
  }
})(typeof window !== 'undefined' ? window : globalThis);
